import { CategoryData } from '../grouped-chart/types';

export const generateStackedChartDataByKeys = (data: CategoryData, keys: string[]) => {
  return {
    ...data,
    items: data.items.map((item) => ({
      categoryValue: item.categoryValue,
      ...keys.reduce((acc, key) => ({ ...acc, [key]: item.values[key] ?? null }), {}),
      stackTotal: keys.reduce((acc, key) => acc + (item.values[key] ?? 0), 0),
    })),
  };
};

export const mergeStackedSeries = (
  data: CategoryData,
  keys: string[],
  mergedKey: string,
): CategoryData => {
  const items = data.items.map((item) => {
    return {
      ...item,
      values: {
        [mergedKey]: keys.reduce((acc, key) => acc + (item.values[key] ?? 0), 0),
      },
    };
  });
  const minValue = Math.min(...items.map((item) => item.values.total));
  const maxValue = Math.max(...items.map((item) => item.values.total));
  return {
    ...data,
    items,
    minValue,
    maxValue,
    series: [
      {
        key: mergedKey,
        label: 'Total',
        compactLabel: 'Total',
        color: 'white',
        type: 'Number',
        axis: data.series.at(0)?.axis ?? 'left',
        chartType: 'bar',
        showValues: false,
        minValue,
        maxValue,
      },
    ],
  };
};
